module.exports = __webpack_public_path__ + "img/08_mpi.48da3ecf.jpg";